import axios from "axios";
import APP_CONFIG from "../app/configuration/AppConfig";

export const getIsDiffuseOptimizationOnAsync = async (
  siteId: string,
  signal?: AbortSignal
): Promise<boolean> => {
  const response = await axios.get(
    `${APP_CONFIG.serviceUrls.apiHostUrl}/diffuseOptimization/${siteId}/status`,
    { signal }
  );
  return response.data;
};
